import { UpdateAbsenceBody, UpdateAbsenceResponse } from '@lmc/ts-common'
import { useMutation, useQueryClient } from 'react-query'
import {
  ABSENCES_QUERY_KEY,
  ABSENCES_URL,
  ABSENCE_UPDATE_QUERY_KEY,
} from './queryConstants'
import { postJSON } from 'common/services/api'
import { showToast } from 'common/utils'

type UseAbsenceUpdateProps = {
  absenceId: string | undefined
  onUpdateSuccess?: () => void
}

type UseAbsenceUpdateReturn = {
  updateAbsence: (values: UpdateAbsenceBody) => Promise<unknown>
  isUpdateLoading: boolean
}

export const useAbsenceUpdate = ({
  absenceId,
  onUpdateSuccess,
}: UseAbsenceUpdateProps): UseAbsenceUpdateReturn => {
  const queryClient = useQueryClient()
  const handleError = (err: any) => {
    showToast({
      title: err?.message as string,
      type: 'error',
    })
  }

  // UPDATE
  const updateFunction = async (values: UpdateAbsenceBody) => {
    return postJSON({
      url: `${ABSENCES_URL}/${absenceId}`,
      method: 'PUT',
      json: values,
      isRota: true,
    })
  }

  const { mutateAsync: updateMutation, isLoading: isUpdateLoading } =
    useMutation<UpdateAbsenceResponse, unknown, UpdateAbsenceBody, unknown>(
      [ABSENCE_UPDATE_QUERY_KEY],
      updateFunction,
      {
        onSuccess: () => {
          onUpdateSuccess?.()
        },
        onError: (err) => handleError(err),
      }
    )

  const updateAbsence = async (values: UpdateAbsenceBody) => {
    try {
      const result = await updateMutation(values)
      queryClient.invalidateQueries(ABSENCES_QUERY_KEY)
      return result
    } catch (err) {
      return err
    }
  }

  return {
    updateAbsence,
    isUpdateLoading,
  }
}
